import * as React from "react";
import Shop from "../../_data/models/Shop";
import Booth from "../../_data/models/Booth";
import * as pluralize from "pluralize";

interface Props {
    booth: Booth;
    shop: Shop;
    viewBooth: () => void;
}

const ActivityFeedBoothItemComponent = (props: Props) => {
    const {booth, shop, viewBooth} = props;
    const count = booth.workstationCount;

    return (
        <div className="row" onClick={viewBooth}>
            <div className="large-12 columns">
                <div className="post-img v-align-center">
                    <a>
                        <img src={booth.primaryPictureUrl || shop.primaryPictureUrl} alt={shop.name}/>
                    </a>
                    <div className="text-wrapper">
                        <h5>{shop.name}</h5>
                        <h6 className="subheader">{shop.address()}</h6>
                        <h6 className="subheader">{count} {pluralize('Booth', count)} For Rent -
                            ${booth.price}/{booth.terms}</h6>
                    </div>
                </div>
            </div>
        </div>

    );
};
export default ActivityFeedBoothItemComponent;


// WEBPACK FOOTER //
// ./app/client/activityFeeds/components/ActivityFeedBoothItemComponent.tsx